import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { HandleError } from '../http-error-handler.service';
import { ReassignProblemPayload, WorkOrder } from 'src/app/state-management';
import { Activity } from 'src/app/models/activity';

@Injectable()
export class WorkOrderService {
  workOrderUrl = 'api/workorder';
  private handleError: HandleError;

  httpOptions = {
    headers: new HttpHeaders({
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    })
  };

  constructor(
    private httpClient: HttpClient
  ) {
  }
  submitWorkOrder(workOrderTypeRefId: number, activity: Activity) {
    return this.httpClient.post<WorkOrder>(this.workOrderUrl + '/createworkorder/' + workOrderTypeRefId.toString(), activity);
  }

  addWorkOrder(workOrderTypeRefId: number, activityId: number, activity: Activity) {
    return this.httpClient.post<WorkOrder>(this.workOrderUrl + '/addworkorder/' + workOrderTypeRefId.toString()
      + '/' + activityId.toString(), activity);
  }

  deleteWorkOrder(activityId: number) {
    return this.httpClient.post<string>(this.workOrderUrl + '/deleteworkorder/' + activityId, null);
  }

}
